import { Directive, Input, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: 'img[appImageFallback]'
})
export class ImageFallbackDirective {
  @Input() fallbackSrc: string;

  constructor() { }

  @HostListener('error', ['$event'])
  onError(event: Event) {
    const target = event.target as HTMLImageElement | null;
    if (!target) {
      return;
    }
    if (this.fallbackSrc) {
      target.src = this.fallbackSrc;
    } else {
      target.src = '../../assets/images/public/BUDefaultLogo.jpeg';
    }
  }
}
